export enum DrawTypeCloud {
  circles = "circles", // 对应ol的Polygon
  polygons = "polygons", // 对应ol的Polygon
  rectangles = "rectangles", // 对应ol的Polygon
  lines = "lines", // 对应ol的LineString
  polylines = "polylines", // 对应ol的LineString
}

export default class base {}
